import { createGenericSlice } from './generic.slice'
import { RootState } from '@store/store'

// Define the Tag type (you should have this defined elsewhere in your project)
export interface TagModel {
  id: string
  tagName: string
  tagDescription: string
  tagAttributes: TagAttribute[]
}

export interface TagAttribute {
  id: string
  attributeDescription: string
  attributeName: string
  attributeType: TagAttributeType[]
  attributeValue: string
}

export enum AttributeType {
  STRING = 'STRING',
  SELECT = 'SELECT',
  WITH_UNITES = 'UNITED',
}

export interface TagAttributeType {
  id: string
  attributeType: AttributeType
  typeName: string
  availableValues?: TagAvailableValue[]
}

export interface TagAvailableValue {
  value?: string
  min?: string
  max?: string
  unit?: string
}

// Create the generic slice for the Tag entity
const {
  slice: tagsSlice,
  thunks: tagThunks,
  adapter: tagsAdapter,
} = createGenericSlice<TagModel>(
  'Tag',
  'tag',
  {} // You can define extra initial state here if needed
)

export const {
  selectAll: selectAllTags,
  // ... other selectors
} = tagsAdapter.getSelectors<RootState>((state: RootState) => state.tags)

export const { fetchAll: fetchAllTags } = tagThunks

export default tagsSlice.reducer
